export default __webpack_public_path__ + "static/program-circle-revived-pl-26858b75ac2645f7186f1799ab203d19.svg";